module.exports = __webpack_public_path__ + "static/scale-model-of-golden-gate-audubon-society-in-oakland-california-51292e1242a3f8f3d98c9243d279ff72.png";